// Firebase configuration and initialization
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics, isSupported as analyticsIsSupported } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyArvv5YczlyQNN1wJixcXOCy76yKywSFJY",
    authDomain: "co-investment.firebaseapp.com",
    projectId: "co-investment",
    storageBucket: "co-investment.firebasestorage.app",
    messagingSenderId: "695027167391",
    appId: "1:695027167391:web:72c3fcd6bf5ec65b2072aa",
    measurementId: "G-TPN61R1DCM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
let analytics = null;
if (typeof analyticsIsSupported === "function") {
    analyticsIsSupported().then(supported => {
        if (supported) {
            analytics = getAnalytics(app);
        }
    });
}
export { analytics };

// Export config for Node.js scripts (CommonJS compatibility)
if (typeof module !== "undefined" && module.exports) {
    module.exports.firebaseConfig = firebaseConfig;
}

export default app;